import React from "react";
import PropTypes from "prop-types";
import "./styles.css";

const getColorValue = (color) => {
  if (!color) {
    return "#9e9e9e";
  }

  const colorMap = {
    gray: "#9e9e9e",
    grey: "#9e9e9e",
  };

  return colorMap[color] || color;
};

const Loading = ({ color, duration, size, styles }) => {
  const numericSize = Number(size);
  const dotSize = Number.isFinite(numericSize) ? Math.max(numericSize, 0) / 2 : 0.5;

  const rootStyle = {
    "--c11n-loading-dot-size": `${dotSize}rem`,
    "--c11n-loading-dot-margin": `0 ${dotSize / 3}rem`,
    "--c11n-loading-color": getColorValue(color),
    "--c11n-loading-duration": `${duration}ms`,
    ...styles.root,
  };

  return (
    <div className="c11n-loading" style={rootStyle}>
      <span className="c11n-loading-dot" style={styles.dot} />
      <span className="c11n-loading-dot" style={styles.dot} />
      <span className="c11n-loading-dot" style={styles.dot} />
    </div>
  );
};

Loading.propTypes = {
  color: PropTypes.string,
  duration: PropTypes.number,
  size: PropTypes.number,
  styles: PropTypes.shape({
    dot: PropTypes.object,
    root: PropTypes.object,
  }),
};

Loading.defaultProps = {
  color: "grey",
  duration: 550,
  size: 1,
  styles: {},
};

export default Loading;
